
import React from 'react';

const Definitions = () => {
  return (
    <div>
      <h3 className="text-xl font-semibold mb-3">II. Definitions</h3>
      <ul className="list-disc pl-6 space-y-2 text-gray-600">
        <li><strong>Personal data:</strong> Any information relating to an identified or identifiable natural person ("data subject"). An identifiable person is one who can be identified, directly or indirectly, in particular by reference to an identifier such as a name, an identification number, location data, an online identifier, or information relating to physical, physiological, genetic, mental, economic, cultural, or social identity.</li>
        <li><strong>Processing:</strong> Any operation performed on personal data, whether or not by automated means.</li>
        <li><strong>Controller:</strong> The natural or legal person which determines the purposes and means of processing.</li>
        <li><strong>Processor:</strong> A party which processes personal data on behalf of the controller.</li>
        <li><strong>Third party:</strong> Any person other than the data subject, controller, or processor.</li>
        <li><strong>Consent:</strong> Freely given, specific, informed, and unambiguous indication of wishes.</li>
      </ul>
    </div>
  );
};

export default Definitions;
